import { createContext } from 'react';

import type { ToastMessage } from './Toaster.types';

export interface ToasterContextValue {
  push: (message: ToastMessage) => void;
  /** @internal */
  initialized: boolean;
}

export const ToasterContext = createContext<ToasterContextValue>({
  push: () => {},
  initialized: false
});
